import { makeEnvironmentProviders } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';
import { CUSTOM_NGX_DATE_FORMATS } from './custom-date-formats';
import moment from 'moment/moment';

class CustomDateAdapter extends NativeDateAdapter {
  override getFirstDayOfWeek(): number {
    // Monday is the first day of the week
    return 1;
  }

  override format(date: Date, displayFormat: Object): string {
    return moment(date).format(displayFormat.toString());
  }
}

export function provideNgxMatCustomDate() {
  return makeEnvironmentProviders([
    { provide: DateAdapter, useClass: CustomDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_NGX_DATE_FORMATS }
  ]);
}
